import { DDI, DDIPutRequest, Device, ROUTE_START } from "callable-data-objects";
import { useAccount } from "Hooks/Endpoints";
import { APIAccountDDIContext } from "Providers/APIContexts";
import React, { useEffect, useState } from "react";
import { DefaultProviderProps } from "./types";

const APIDDIProvider = ({ children }: DefaultProviderProps) => {
  const { account, select: selectAccount, ddiService } = useAccount();
  const [ddis, setDDIs] = useState<DDI[]>([]);
  const [ddi, setDDI] = useState<DDI | undefined>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    list();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account]);

  function unload() {
    setTimeout(() => {
      setLoading(false);
    }, 300);
  }

  async function list() {
    setLoading(true);
    const resp = await ddiService?.list();
    if (resp) setDDIs(resp);
    unload();
  }

  async function select(id: string) {
    setLoading(true);
    const resp = await ddiService?.get(id);
    if (resp) setDDI(resp);
    unload();
  }

  function unselect() {
    setDDI(undefined);
  }

  async function update(payload: DDIPutRequest) {
    if (ddi && account) {
      setLoading(true);
      await ddiService?.put(ddi.id, payload);
      await list();
      await selectAccount(account.id);
      unselect();
      unload();
    }
  }

  async function release() {
    if (ddi && account) {
      await ddiService.delete(ddi.id);
      selectAccount(account.id);
      unselect();
    }
  }

  function isMBN() {
    return ddi && account && account.mbn === ddi.name;
  }

  function isAttached() {
    if (ddi && account) {
      const found =
        account.devices
          .filter((d: Device) => d.type === ROUTE_START)
          .find((d: Device) => d.startRoute.ddis.indexOf(ddi.id) > -1) !==
        undefined;
      return found;
    }
    return false;
  }

  return (
    <APIAccountDDIContext.Provider
      value={{
        loading,
        account,
        ddis,
        ddi,
        select,
        unselect,
        update,
        release,
        isMBN,
        isAttached,
      }}
    >
      {children}
    </APIAccountDDIContext.Provider>
  );
};

export default APIDDIProvider;
